import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from "react-icons/fa";
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle,
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/open-cascavel-international-de-jiu-jitsu-2025/tabela-open-cascavel-international-de-jiu-jitsu-2025.jpg";
import qrCodecopaAmizadeDeJiuJitsu2024 from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2024/qr-coce--copa-amizade-de-jiu-jitsu-2024.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import cascavel from "../../assets/images/sponsors/govCascavel.jpeg";
import agitoTur from "../../assets/images/sponsors/agito-tur.jpeg";
import goldStar from "../../assets/images/sponsors/gold-star.jpeg";
import prefeituraParana from "../../assets/images/sponsors/govParana.jpg";

//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import {
  SponsorContainer,
  SponsorList,
} from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors = [
  /*    { img: contabilizaNhamunda  },
    { img: infonLine },
    { img: prefeituraNhamunda },
    { img: contabilizaAm }, */
  { img: torneio, url: "http://www.torneiofacil.com" },
];

const support = [
  { img: torneio, url: "http://www.torneiofacil.com" },
  { img: cascavel },
  { img: agitoTur },
  { img: goldStar },
  { img: prefeituraParana },
];

const dataEvento = "21 de setembro de 2025 ";
const horaEvento = "9:00h da manhã";
const tituloEvento = "Cascavel International Open de Jiu Jitsu Gi e Nogi";
const localEvento = "Ginásio de Esportes Ciro Nardi";
const endereçoEvento =
  "R. Barão do Cerro Azul, 484 - Centro, Cascavel - PR,CEP 85801-080";
const dataDeEncerramentoIncricao = "16/SET/2025";
const horaDeEncerramentoIncricao = "23h:59";

const dataDeEncerramentoCorrecao = "16/SET/2025";
const horaDeEncerramentoCorrecao = "23h:59min";

const dataDeEncerramentoInscricaoLote1 = "20/JUL/2025";
const dataDeEncerramentoInscricaoLote2 = "24/AGO/2025";
const dataDeEncerramentoInscricaoLote3 = "16/SET/2025";

const valorinscricaoCategoriaLote1 = "100,00 (cem reais)";
const valorinscricaoCategoriaLote2 = "120,00 (cento e vinte reais)";
const valorinscricaoCategoriaLote3 = "140,00 (cento e quarenta reais)";
const valorinscricaoLote1ComboGieNogi = "150,00 (cento e cinquenta reais)";
const valorinscricaoLote2ComboGieNogi = "180,00 (cento e oitenta reais)";
const valorinscricaoLote3ComboGieNogi = "200,00 (duzentos reais)";

const dataDeEncerramentoInscricaoLoteUnico = "13/MAI/2025";
const valorinscricaoCategoriaLoteUnico = "100,00 (cem reais)";
const valorinscricaoComboGieNogi = "150,00 (cento e cinquenta reais)";

const valorinscricaoAbsolutoLoteUnico = "100,00 (cem reais)";
const valorinscricaoAbsolutoLote2 = "75,00 (setenta e cinco reais)";

const dataDeDivulgacaoChaves = "20/SET/2025";
const horaDeDivulgacaoChaves = "23h:59min";

const instituicaoBancaria = "Bradesco";
const tipoDeChavePix = "Telefone";
const ChavePix = "(92) 99468-5161";
const BeneficiarioDaChavePix = "José Michel Tavares Pio";

const dataDeDivulgacaoCronograma = " ";
const horaDeDivulgacaoCCronograma = " ";

const contatoWhatsApp = "(92) 99468-5161";
const contatoWhatsAppTorneio = "+55 (11) 94456-3515";

const slugGI = "open-cascavel-international-de-jiu-jitsu-cascavel-pr-gi";
const slugNOGI = "open-cascavel-international-de-jiu-jitsu-cascavel-pr-nogi";
const rotaInscriçãoGi =
  "/enrollment/open-cascavel-international-de-jiu-jitsu-cascavel-pr-gi";
const rotaChecagemGi =
  "/check/open-cascavel-international-de-jiu-jitsu-cascavel-pr-gi/search";
const rotaChecagemNoGi =
  "/check/open-cascavel-international-de-jiu-jitsu-cascavel-pr-nogi/search";
const rotaChavesGI =
  "/tournament/keys/open-cascavel-international-de-jiu-jitsu-cascavel-pr-gi";
const rotaChavesNoGi =
  "/tournament/keys/open-cascavel-international-de-jiu-jitsu-cascavel-pr-nogi";

const OpenCascavelInternationalDeJiuJitsu2025: React.FC = () => {
  useEffect(() => {
    // Adiciona cache buster se não estiver presente
    if (!window.location.search.includes("cacheBuster")) {
      const cacheBuster = `cacheBuster=${new Date().getTime()}`;
      const newUrl = `${window.location.pathname}?${cacheBuster}`;
      window.location.replace(newUrl); // Redireciona para a nova URL
    }
  }, []);

  const { authenticated } = useAuthenticate();
  const navigate = useNavigate();
  const [tournamentGI, setTournamentGI] = useState<any>();
  const [tournamentNOGI, setTournamentNOGI] = useState<any>();

  useEffect(() => {
    api.get(`/tournaments/${slugGI}`).then(({ data }) => {
      setTournamentGI(data);
    });

    api.get(`/tournaments/${slugNOGI}`).then(({ data }) => {
      setTournamentNOGI(data);
    });
  }, []);

  const handleToSubscriptionPage = (url: string) => {
    if (tournamentGI!.canSubscribe || tournamentNOGI!.canSubscribe) {
      navigate(url);
      return;
    }

    const msg = "Período de inscrição encerrado.";

    Swal.fire({
      title: "Atenção!",
      text: msg,
      icon: "error",
    });

    toast.error(msg);
  };
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/open-cascavel-international-de-jiu-jitsu-2025/open-international-de-jiu-jitsu-2025.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/open-cascavel-international-de-jiu-jitsu-2025/open-international-de-jiu-jitsu-2025.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <FaMapMarkerAlt
                    style={{ marginRight: "8px", color: "red" }}
                  />
                  <a
                    target={"blank"}
                    style={{
                      color: "#000",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                    href="https://maps.app.goo.gl/ECRR3A1vLo7T9GHn6"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />
          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors &&
                    sponsors.map((buttons: any, index: number) => (
                      <SponsorButton
                        key={index} // Adicionei uma chave única para cada botão
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                        target="_blank" // Adicione este atributo
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content
              style={{
                marginTop: "32px",
              }}
            >
              <EditalContainer>
                <EditalTitle>
                  EDITAL {tituloEvento.toLocaleUpperCase()}
                </EditalTitle>
                <EditalContent>
                  <Span>
                    O {tituloEvento} é um evento tradicional que fomenta e
                    incentiva a prática do jiu jitsu na cidade de Cascavel-PR .
                    As lutas serão GI (com kimono) e NOGI (sem kimono), o evento
                    disponibilizará categorias para todas as idades e faixas,
                    conforme as tabelas de peso deste edital. Os competidores
                    terão a oportunidade de testar suas habilidades em um
                    ambiente controlado e com acompanhamento de profissionais
                    qualificados.
                  </Span>
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando
                    diariamente as recomendações dos Órgãos de Saúde e este
                    protocolo pode ser atualizado a qualquer momento caso novas
                    determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as
                    inscrições serão automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos
                    participantes, tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor
                    verifique sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um
                    paciente diagnosticado com Covid-19, por favor fique em casa
                    e procure seu médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES MEDALHAS + DINHEIRO💰🥇">
                  <H3>Academias:</H3>
                  <H5>Academias com maior número de atletas inscritos</H5>
                  <P>1° lugar: 💰 R$1000,00 </P>
                  <P>2° lugar: 💰 R$600,00</P>
                  <P>3° lugar: 💰 R$400,00</P>
                  <H5>Pré-Mirim a Infanto Juvenil</H5>
                  <P>1° lugar: 🏆 Troféu + 💰 R$800,00 </P>
                  <P>2° lugar: 🏆 Troféu + 💰 R$500,00</P>
                  <P>3° lugar: 🏆 Troféu + 💰 R$300,00</P>
                  <H5>Juvenil a Masters</H5>
                  <P>1° lugar: 🏆 Troféu + 💰 R$800,00 </P>
                  <P>2° lugar: 🏆 Troféu + 💰 R$500,00</P>
                  <P>3° lugar: 🏆 Troféu + 💰 R$300,00</P>

                  <br />
                  <H3>Absoluto Masculino GI:</H3>
                  <H5>Infanto Juvenil 14 e 15 todos Juntos </H5>
                  <P>1° lugar: R$200,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Juvenil Branca </H5>
                  <P>1° lugar: R$200,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Juvenil Graduado </H5>
                  <P>1° lugar: R$200,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto Branca</H5>
                  <P>1° lugar: R$300,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto Azul</H5>
                  <P>1° lugar: R$400,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto Roxa</H5>
                  <P>1° lugar: R$500,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto Marrom</H5>
                  <P>1° lugar: R$600,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto Preta</H5>
                  <P>1° lugar: R$800,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Master 1 e 2 Branca</H5>
                  <P>1° lugar: R$300,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Master 1 e 2 Azul</H5>
                  <P>1° lugar: R$300,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Master 1 e 2 Roxa</H5>
                  <P>1° lugar: R$400,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Master 1 e 2 Marrom e Preta - (Juntos)</H5>
                  <P>1° lugar: R$800,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>

                  <br />

                  <H3>Absoluto Feminino GI:</H3>
                  <H5>Infanto Juvenil 14 e 15 todas Juntas </H5>
                  <P>1° lugar: R$200,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Juvenil Branca</H5>
                  <P>1° lugar: R$200,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Juvenil Graduadas</H5>
                  <P>1° lugar: R$200,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto Branca</H5>
                  <P>1° lugar: R$300,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto Azul e Roxa - (Juntas)</H5>
                  <P>1° lugar: R$500,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto Marrom e Preta - (Juntas)</H5>
                  <P>1° lugar: R$800,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Master 1 e 2 Branca</H5>
                  <P>1° lugar: R$300,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Master 1 e 2 Azul/Roxa - (Juntas)</H5>
                  <P>1° lugar: R$400,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <br />

                  <H3>Absoluto Masculino NOGI:</H3>
                  <H5>Adulto e Master Branca - (Juntos)</H5>
                  <P>1° lugar: R$300,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto e Master Azul/Roxa - (Juntos)</H5>
                  <P>1° lugar: R$500,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto e Master Marrom/Preta - (Juntos)</H5>
                  <P>1° lugar: R$700,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <br />
                  <H3>Absoluto Feminino NOGI:</H3>
                  <H5>Adulto e Master Branca - (Juntas)</H5>
                  <P>1° lugar: R$300,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto e Master Azul/Roxa - (Juntas)</H5>
                  <P>1° lugar: R$500,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <H5>Adulto e Master Marrom/Preta - (Juntas)</H5>
                  <P>1° lugar: R$700,00 + Medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <br />
                  <H3>Demais Categorias GI e NOGI</H3>
                  <P>1° lugar: medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <br />
                  <p>
                    Estas premiações só irão valer para os Absolutos GI (COM
                    KIMONO) e NOGI (SEM KIMONO) que tiverem 06 (SEIS) ou mais
                    atletas inscritos.
                  </p>
                  <p>
                    Em caso de apenas 06 (SEIS) ou menos inscritos no Absoluto,
                    a premiação será 50% do valor total.
                  </p>

                  <P>
                    Para a realização de lutas na categoria absoluto, é exigido
                    um mínimo de 6 atletas inscritos.
                  </P>
                  <p>
                    Mais informações sobre as inscrições para o absoluto está
                    disponível na seção INSCRIÇÕES, parágrafo Inscrição de
                    Absoluto deste edital.
                  </p>
                  <br />
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente
                    online, por meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável
                    legal deverá selecionar corretamente a categoria referente
                    idade que o atleta completará no ano de 2025, bem como sua
                    faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele
                    terá em 2025, conforme regra da CBJJ.
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até{" "}
                    {dataDeEncerramentoIncricao}, às
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a
                    confirmação do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor
                    responsável poderá corrigir as informações no site
                    www.torneiofacil.com.br, acessando a opção Meu Perfil em
                    seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponivel até o encerramento
                    das inscrições {dataDeEncerramentoCorrecao} às{" "}
                    {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas
                    modificações nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão
                    sujeitos a desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação
                    do pagamento da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento
                    das inscrições {dataDeEncerramentoCorrecao} às{" "}
                    {horaDeEncerramentoCorrecao}.
                  </P>
                  <H3>Checagem</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em{" "}
                    {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria poderão se increver e
                    participar do absoluto.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a
                    categoria da sua inscrição no torneio. Exceção apenas para
                    os master que poderá se inscrever como absoluto adulto.
                  </P>
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento
                    da inscrição, sua condição pelo WhatsApp. Caso contrário o
                    atleta será desclassificado sem direito a reembolso.
                  </H3>
                  {/*             <P>
                    Haverá um horário reservado de 11:00h às 11:30 para todos os atletas PCD .
                  </P> */}
                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>As inscrições serão divididas em três lotes:</Span>
                  <br />
                  <H3>
                    Lote 1- Pagamento até {dataDeEncerramentoInscricaoLote1}
                  </H3>
                  <P>
                    Inscrição GI ou NOGI categoria R${" "}
                    {valorinscricaoCategoriaLote1}
                  </P>
                  <P>
                    Inscrição Combo GI+NOGI R$ {valorinscricaoLote1ComboGieNogi}
                  </P>
                  <br />
                  <H3>
                    Lote 2- Pagamento até {dataDeEncerramentoInscricaoLote2}
                  </H3>
                  <P>
                    Inscrição GI ou NOGI categoria R${" "}
                    {valorinscricaoCategoriaLote2}
                  </P>
                  <P>
                    Inscrição Combo GI+NOGI R$ {valorinscricaoLote2ComboGieNogi}
                  </P>
                  <br />
                  <H3>
                    Lote 3- Pagamento até {dataDeEncerramentoInscricaoLote3}
                  </H3>
                  <P>
                    Inscrição GI ou NOGI categoria R${" "}
                    {valorinscricaoCategoriaLote3}
                  </P>
                  <P>
                    Inscrição Combo GI+NOGI R$ {valorinscricaoLote3ComboGieNogi}
                  </P>
                  <br />
                </Collapse>
                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a
                    operação de pagamento.
                  </H3>
                  {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

                {/* <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                    <H3>
                      Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                      inscrição, sendo obrigatório a comprovação e apresentação de atestado
                      médico.
                    </H3>
                    <H3>
                      Após o fim do período de inscrição não será possível o reembolso das
                      inscrições pagas.
                    </H3>
                  </Collapse> */}

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Uma vez PAGA a inscrição, o atleta tem direito ao reembolso
                    nas seguintes situações:
                  </H3>
                  <P>1) Quando o evento é CANCELADO.</P>
                  <P>2) Quando ocorre alteração na DATA do evento.</P>
                  <P>
                    3) Quando altera o LOCAL do evento com distância maior que
                    20km em relação ao anterior.
                  </P>
                  <P>
                    4) Quando há diminuição da premiação, somente para os
                    atletas impactados.
                  </P>
                  <H3>
                    Obs: Para os 4 casos acima, o prazo máximo para solicitar
                    reembolso será de o dia 15 de setembro de 2025.
                  </H3>
                  <P>
                    5) Quando o atleta se lesionar (desde que apresente um laudo
                    médico comprovando a lesão até o dia 15 de setembro de 2025,
                    através do nosso WhatsApp). Neste caso da garantia, o
                    atleta usufrui do reembolso de 80% do valor pago na
                    inscrição.
                  </P>
                  <P>
                    Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL
                    e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA
                    MAIOR, o atleta NÃO TEM direito ao reembolso. Para estes casos, 
                    a organização oferecerá alternativas para
                    uso do crédito do atleta que não puder comparecer na nova
                    data do evento, ao invés do reembolso, desde que o atleta
                    nos notifique pelo WhatsApp até o dia 15 de setembro de 2025
                    antecedente ao evento).
                  </P>
  
                  <P>
                    Após os períodos predeterminados, o atleta perderá o direito
                    a reembolso ou crédito.
                  </P>
                  <H3>
                    Além disso, o atleta NÃO tem direito a reembolso de valores
                    quando:
                  </H3>
                  <P>1) Está sozinho na chave de luta.</P>
                  <P>2) Desistência por qualquer motivo.</P>
                  {/* <H3>
                      Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                      inscrição, sendo obrigatório a comprovação e apresentação de atestado
                      médico.
                    </H3>
                    <H3>
                      Após o fim do período de inscrição não será possível o reembolso das
                      inscrições pagas.
                    </H3> */}
                </Collapse>

                <Collapse title="REGRAS">
                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas
                    e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas
                    a serem observadas serão aquelas estabelecidas pela
                    Confederação Brasileira de Jiu-Jitsu (CBJJ), em conformidade
                    com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de
                    peso para cada categoria, encontra-se disponível no site
                    oficial do evento, acessível por meio do botão denominado
                    "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela
                    cbjj branco, azul e preto ) os kimonos devem estar limpos
                    sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho
                    no sorteio da chave estará automaticamente na final. Em caso
                    de WO de um atleta, os dois lutadores restantes na categoria
                    disputarão a final.
                  </Span>
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor
                    deverá apresentar documento oficial com foto no momento da
                    pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da
                    categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que
                    entiverem inscritos serão automaticamente desclassificados e
                    não poderão lutar o Absoluto.
                  </Span>
                  <Span>
                    Será realizada apenas uma pesagem oficial por atleta.
                  </Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os
                    atletas.
                  </Span>
                  <Span>
                    Teremos duas balanças para pesagem oficial dos atletas.
                  </Span>
                  {/*  <Span>Teremos 4 (quatro) aréas de lutas</Span>
                  <Span>A Arbitragem será composta pela Equipe da Federação de Arbítrio do Amazonas</Span> */}
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não
                    poderão lutar com a faixa abaixo. Se descoberto, o
                    competidor será eliminado do torneio sem direito a
                    reembolso.
                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                  <H5>Categoria e Absoluto, todas as faixas</H5>
                  <P>1° lugar: 9 pontos</P>
                  <P>2° lugar: 3 pontos</P>
                  <P>3° lugar: 1 ponto</P>

                  <P>
                    A organização do evento irá confeccionar um crachá para
                    disponibilizar a apenas um representante por equipe.
                  </P>
                  <P>
                    O representante que for escolhido a usar o crachá fará todas
                    as funções necessárias sobre sua equipe com relação ao
                    evento.
                  </P>
                  <P>
                    Só ficará 01 representante de cada equipe para tirar todas
                    as dúvidas e os questionamentos só serão aceito vindo do
                    mesmo.
                  </P>
                  <P>
                    O mesmo representante de cada academia finalista subirá no
                    pódio, podendo ter em suas mão a somente a bandeira da
                    academia que foi inscrita no evento.
                  </P>
                  <P>
                    Crianças até 11 anos, poderão ser acompanhadas em sua área
                    de luta apenas com o representante de sua equipe.
                  </P>
                  <P>
                    A contagem dos pontos será realizada de forma geral
                    contabilizando os pontos de todas as faixas.
                  </P>
                  <P>
                    Campeão direto não contam pontos, chaves com apenas um
                    inscrito.
                  </P>
                  <P>
                    Campeão por WO, devido a desistencia do oponente, contará
                    pontos desde que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com apenas dois atletas da mesma academia não
                    contam pontos para a disputa por academias.
                  </P>
                  <br />
                  <H3>Para o absoluto:</H3>
                  <P>Não será permitido luta combinada.</P>
                  <P>Não será permitido fechamento dos finalista.</P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim
                    de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima , a organização fica
                    sem a obrigação de fazer a entrega da premiação citado nesse
                    edital.
                  </P>
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver
                    no livro de regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse
                  title={
                    "CRONOGRAMA" +
                    dataDeDivulgacaoCronograma +
                    " " +
                    horaDeDivulgacaoCCronograma
                  }
                >
                  
                  <Container>
                  <span>
                    CASCAVEL INTERNATIONAL OPEN DE JIU JITSU GI E NOGI 2025

                    </span>
                    <br />
                    <span>
                    Data: 21 de setembro de 2025

                    </span>
                    <br />
                    <span>
                    Local: Ginásio de Esportes Ciro Nardi
                    </span>
                    <br />
                    <br />
                    <h5>09:00 - Abertura do evento e Hino Nacional</h5>
                    <h5>09:30 - Categorias Pré-Mirim e Mirim A - Todas as Faixas masculino/feminino</h5>
                    <h5>10:00 - Categoria Mirim B - Todas as Faixas masculino/feminino</h5>
                    <h5>10:30 - Infantil A - Todas as Faixas masculino/feminino</h5>
                    <h5>11:00 - Infantil B - Todas as faixas masculino/feminino</h5>
                    <h5>11:30 - Infanto-juvenil Todas as faixas masculino/feminino</h5>
                    <h5>12:00 - Juvenil - Todas as faixas masculino/feminino</h5>
                    <h5>12:30 - Marrom e Preta Adulto e Master masculino/feminino</h5>
                    <h5>13:00 - Faixa Branca Adulto e Master masculino/feminino</h5>
                    <h5>13:30 - Faixa Azul Adulto e Master masculino/Feminino</h5>
                    <h5>14:00 - Faixa Roxa Adulto e Master masculino/feminino</h5>
                    <h5>14:30 - Início dos Absoluto</h5>
                    <h5>15:00 - Todas as Categorias NOGI - Todas as faixas masculino/feminino</h5>
                    

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li>
                      <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li>
                      <li>O cronograma pode ser adiantado em até 1 hora, e atrasar conforme a necessidade do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li>
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss 
                    {/*  <br />
                    <span>
                      CRONOGRAMA III COPA BJJ CASCAVEL DE JIU JITSU 2025

                    </span>
                    <h5>09:15 - Categorias Pré-Mirim e Mirim A - Todas as faixas Masculino/Feminino (área de aquecimento)</h5>
                    <h5>09:30 - Abertura e início do evento</h5>
                    <h5>09:45 - Mirim B - Todas as faixas Masculino/Feminino</h5>
                    <h5>10:15 - Infantil A - Todas as faixas Masculino/Feminino</h5>
                    <h5>10:45 - Infantil B - Todas as faixas Masculino/Feminino</h5>
                    <h5>11:15 - Infanto-Juvenil - Todas as faixas Masculino/Feminino</h5>
                    <h5>11:45 - Juvenil - Todas as faixas Masculino/Feminino</h5>
                    <h5>12:00 - Faixas Marrom e Preta Adulto e Master Masculino/Feminino</h5>
                    <h5>12:30 - Faixa Branca Adulto Masculino/Feminino</h5>
                    <h3>Início NOGI</h3>
                    <h5>13:15 - Faixa Branca Master Masculino/Feminino</h5>
                    <h5>13:45 - Faixa Azul Adulto e Master Masculino/Feminino</h5>
                    <h5>14:00 - Absolutos Juvenil</h5>
                    <h5>14:15 - Faixa Roxa Adulto e Master Masculino/Feminino</h5>
                    <h5>15:00 - Início dos Absolutos Adulto/Master</h5>

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li>
                      <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li>
                      <li>O cronograma pode ser adiantado em até 1 hora, e atrasar conforme a necessidade do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li>
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss */}
                  </Container>
                </Collapse>

                <Collapse title="ENTRADA">
                  {/* <P>Entrada liberada ao público.</P> */}
                  <br />
                  <P>
                    Será cobrado 1kg de alimento não perecível na entrada para
                    atletas e público.
                  </P>
                  <br />
                  <P>
                    Crianças até 5 anos ficam isentas de qualquer tipo de
                    pagamento.
                  </P>
                  <br />
                </Collapse>

                <Collapse title="CONTATO">
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção,
                    checagem ou sugestão de melhorias entre em contato com a
                    equipe do Torneio Fácil por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*CASCAVEL%20INTERNATIONAL%20OPEN%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>
                      Telefone/WhatsApp: {contatoWhatsAppTorneio}{" "}
                    </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              {authenticated ? (
                <>
                  {/* <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi">
                    Inscrição GI
                  </TournamentEnrollmentLinkEndpage>
                  <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi">
                    Inscrição NOGI
                  </TournamentEnrollmentLinkEndpage> */}

                  <TournamentEnrollmentLinkEndpage
                    to={""}
                    onClick={() => handleToSubscriptionPage(rotaInscriçãoGi)}
                  >
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              ) : (
                <>
                  <TournamentEnrollmentLinkEndpage
                    to=""
                    onClick={() => handleToSubscriptionPage("/login")}
                  >
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/login">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              )}
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>

              <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink>

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              <TournamentLink
                // target="_blank"
                href={rotaChavesGI}
              >
                Chaves GI
              </TournamentLink>
              <TournamentLink
                // target="_blank"
                href={rotaChavesNoGi}
              >
                Chaves NOGI
              </TournamentLink>

              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default OpenCascavelInternationalDeJiuJitsu2025;
